import { render, staticRenderFns } from "./PatientDatePickerComponent.vue?vue&type=template&id=5775cd14"
import script from "./PatientDatePickerComponent.vue?vue&type=script&lang=js"
export * from "./PatientDatePickerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports